import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, Tooltip, notification, Select, Tabs, DatePicker, Row, Col, Checkbox } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'
import { FaServer } from "react-icons/fa";
import { connect } from "react-redux";
import { FaAmazonPay, FaRegEdit } from "react-icons/fa";
import ListFollowUps from "../../../components/_utils/listInvoiceFollowUp";
import InvoiceView from '../../../components/DocumentViews/invoiceView';
import EditInvoiceView from "../../../components/Invoice/editInvoiceView"
import InboxEmailView from '../../../components/Invoice/inboxEmailView';
import InvoiceUpdateForm from '../../../components/Invoice/invoiceUpdateForm';
import InvoiceStudentList from '../../../components/Invoice/invoiceStudentList';
import LatestFollowup from '../../../components/_utils/latestFollowup';
import async from 'async';
import GroupedPerformaInvoice from '../../../components/Invoice/groupedPerformaInvoice'
import EditNewInvoiceView from '../../../components/Invoice/editNewInvoiceView'
import GroupInvoiceChangeStatus from '../../../components/Invoice/GroupInvoiceChangeStatus'
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';

let userCheckBox = {}
let invoiceDataForGroup = {}

const Option = Select.Option
const { RangePicker, MonthPicker } = DatePicker
let invoiceObj = {};
class CollapseViewCourse extends Component {
    state = {
        cp: false,
        allUsers: [],
    }

    render() {
        const { cp } = this.state
        const clondData = this.props.children
        return <React.Fragment>
            <div>
                <div className={cp ? styles.questioncollapse : styles.questioncollapsenot}>
                    {clondData && clondData.course.slice(0, cp ? (clondData.course.length) : 1).map((item) => {
                        return <ul className={styles.ul}>
                            <li><b>{item.courseName}{item.campusName && `(${item.campusName})`}</b></li>
                            <li>{item.universityInstitutionName}</li>
                            <li>
                                <small>{item.univData && item.univData.universityCityId && `${item.univData.universityCityId.cityName} ,`}
                                    {item.univData && item.univData.universityStateId && `${item.univData.universityStateId.stateName} ,`}
                                    {item.univData && item.univData.universityCountryId && `${item.univData.universityCountryId.countryName}`}</small>
                            </li>


                        </ul>

                    })}

                </div>
                {clondData && clondData.course && clondData.course.length > 1 ?
                    <button style={{ color: 'red', float: 'right' }} onClick={() => {
                        this.setState({
                            cp: !cp
                        })
                    }}>
                        {cp ? <p>View Less - </p> : <p>View More + </p>}
                    </button> : null}
            </div>
        </React.Fragment>
    }
}
class GroupedInvoices extends Component {

    state = {
        id: '',
        total: 0,
        activeTab: '0',
        refreshChild: false,
        bonusAny: '',
        universityId: '',
        universities: [],
        courses: [],
        showInvoiveView: false,
        showEditInvoiceView: false,
        showInvoiveInboxView: false,
        showInvoiceUpdateForm: false,
        showInvoiceStudentList: false,
        generatedInvoice: {},
        universityInstitutionName: '',
        bankData: {},
        branchDetails: {},
        userCheckBox: {},
        invoiceType: '',
        invoiceStatus: '',
        invoiceData: [],
        invoiceId: '',
        branchId: '',
        branchs: [],
        invoiceDataForGroup: {},
        showGenerateGroupPerforma: false,
        time: {
            from: null,
            to: null
        },
        courseStartDate: {
            from: '',
            to: ''
        },
        cp: false,
        showEditNewInvoiceView: false,
        showGroupInvoiceStatus: false,
    }

    // apiRequest = params => {
    //     return new Promise(async resolve => {
    //         let params = {}
    //         params.results = 100000
    //         params.count = 100000
    //         params.time = this.state.time;
    //         params.branchId = this.state.branchId;
    //         if (this.state.universityInstitutionName) {
    //             params.universityInstitutionName = this.state.universityInstitutionName;
    //         }

    //         if (this.state.courseStartDate && this.state.courseStartDate.from) {
    //             params['invoices.generationActualDate'] = {
    //                 $gte: this.state.courseStartDate.from,
    //                 $lte: this.state.courseStartDate.to
    //             };
    //         }

    //         let searchParams = new URLSearchParams(this.props.search);
    //         let invId = searchParams.get("invId");
    //         let invSTId = searchParams.get("invSTId");
    //         let invoiceType = null;
    //         let invoiceStatus = null;

    //         if (this.props.location.pathname == '/finance-desk-performa') {
    //             invoiceType = 'Performa';
    //         } else if (this.props.location.pathname == '/finance-desk-performa') {
    //             invoiceType = 'Invoice';
    //         } else if (this.props.location.pathname == '/finance-desk-pending') {
    //             invoiceStatus = 'Pending';
    //         } else if (this.props.location.pathname == '/finance-desk-received') {
    //             invoiceStatus = 'Received';
    //         }

    //         if (this.state.invoiceType) {
    //             params.invoiceType = this.state.invoiceType;
    //         } else if (invoiceType) {
    //             params.invoiceType = invoiceType;
    //         }

    //         if (this.state.invoiceStatus) {
    //             params.invoiceStatus = this.state.invoiceStatus;
    //         } else if (invoiceStatus) {
    //             params.invoiceStatus = invoiceStatus;
    //         }

    //         if (invId) {
    //             params["_id"] = invId;
    //         }
    //         if (invSTId) {
    //             params["invoices.invoiceGeneratedRecordId"] = invSTId;
    //         }

    //         this.setState({ exportParams: params })
    //         let data = await Request.getGeneratedInvoices({
    //             ...params,
    //             regExFilters: [
    //                 'invoiceNumber',
    //             ],
    //             sortField: 'invoiceGeneratedDate',
    //             sortOrder: 'decend'
    //         })

    //         let employeesCheckBox = {}
    //         async.each(data.data, (dataItem) => {
    //             if (!employeesCheckBox[dataItem._id]) {
    //                 employeesCheckBox[dataItem._id] = {
    //                     _id: dataItem._id,
    //                     isChecked: false
    //                 }
    //             }
    //         });
    //         userCheckBox = employeesCheckBox
    //         let invoiceData = []
    //         _.each(data.data, (item) => {
    //             item.invoices.map((invoice) => {
    //                 invoiceData.push({
    //                     _id: item._id, grouped: item.grouped ? item.grouped : false, structure: item.structure ? item.structure : 'old', invoiceNumber: item.invoiceNumber, invoiceGeneratedDate: item.invoiceGeneratedDate, invoiceStatus: item.invoiceStatus, invoiceType: item.invoiceType, studentName: invoice.studentName, passportNumber: invoice.passportNumber, instituteStudentId: invoice.instituteStudentId, studentBranchName: invoice.studentBranchName, commissionSubTotal: item.commissionSubTotal, commissionTaxTotal: item.commissionTaxTotal, commissionGrandTotal: item.commissionGrandTotal, createdByUser: item.createdByUser, inquiry: invoice.inquiry ? invoice.inquiry : null,
    //                     commissionFromCourse: invoice.commissionFromCourse, commissionTypeFrom: invoice.commissionTypeFrom, currency: invoice.currency, commissionTotal: invoice.commissionTotal, tutionFee: invoice.tutionFee, studentVisionId: invoice.studentVisionId, conversionRate: invoice.conversionRate, receivedCommissionAmount: invoice.receivedCommissionAmount,
    //                     branchDetails: invoice.inquiry && invoice.inquiry.associativePartnerId != null ? this.state.branchDetails[invoice.inquiry.associativePartnerId] : this.state.branchDetails[invoice.studentBranchId]
    //                 })
    //             })
    //         })

    //         this.setState({ total: invoiceData.length, invoiceData: invoiceData, userCheckBox: userCheckBox })
    //         resolve(data)
    //     })
    // }
    apiRequest = params => {
        return new Promise(async resolve => {
            if (!params) {
                params = {};
            }
            // let params = {}
            params.results = 100000
            params.count = 100000
            params.time = this.state.time;
            params.branchId = this.state.branchId;

            if (this.state.universityInstitutionName) {
                params.universityInstitutionName = this.state.universityInstitutionName;
            }

            if (this.state.courseStartDate && this.state.courseStartDate.from) {
                params['invoices.generationActualDate'] = {
                    $gte: this.state.courseStartDate.from,
                    $lte: this.state.courseStartDate.to
                };
            }

            let searchParams = new URLSearchParams(this.props.search);
            let invId = searchParams.get("invId");
            let invSTId = searchParams.get("invSTId");
            let invoiceType = null;
            let invoiceStatus = null;
            let showGroupedInvoice = false;

            if (this.props.location.pathname == '/finance-desk-performa') {
                invoiceType = ["Performa", "Grouped Performa"];
                params.invoices = "Performa";
            } else if (this.props.location.pathname == '/finance-desk-pending') {
                invoiceStatus = 'Pending';
            } else if (this.props.location.pathname == '/finance-desk-received') {
                invoiceStatus = 'Received';
            } else if (this.props.location.pathname == '/grouped-performa-invoice') {
                invoiceType = 'Performa';
                showGroupedInvoice = true;
            } else if (this.props.location.pathname == "/finance-desk") {
                invoiceType = "Invoice";
            }

            if (this.state.invoiceType) {
                params.invoiceType = this.state.invoiceType;
            } else if (invoiceType) {
                params.invoiceType = invoiceType;
            }

            if (this.state.invoiceStatus) {
                params.invoiceStatus = this.state.invoiceStatus;
            } else if (invoiceStatus) {
                params.invoiceStatus = invoiceStatus;
            }

            if (invId) {
                params["_id"] = invId;
            }
            if (invSTId) {
                params["invoices.invoiceGeneratedRecordId"] = invSTId;
            }
            this.setState({ exportParams: params, showGroupedInvoice })
            let data = await Request.getGeneratedInvoices({
                ...params,
                regExFilters: [
                    'invoiceNumber',
                ],
                sortField: 'invoiceGeneratedDate',
                sortOrder: 'decend'
            })

            let employeesCheckBox = {}
            async.each(data.data, (dataItem) => {
                if (!employeesCheckBox[dataItem._id]) {
                    employeesCheckBox[dataItem._id] = {
                        _id: dataItem._id,
                        isChecked: false
                    }
                }
            });
            userCheckBox = employeesCheckBox

            this.setState({ total: data.total, invoiceData: data.data });
            resolve(data);
        })
    }
    loadUniversity = async () => {
        Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
            .then(resp => {
                resp.arr = resp.arr.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.universityInstitutionName })
                    return temp
                }, [])

                this.setState({ universities: resp.arr });
            })
            .catch(err => {
                console.log(err)
            })
    }

    generateGroupedPerformaInvoice = () => {
        let userArr = _.filter(this.state.userCheckBox, (item) => {
            return item.isChecked;
        });
        if (userArr && userArr.length) {
            invoiceDataForGroup = {
                usersData: userArr,
            }
            this.setState({ showGenerateGroupPerforma: true, invoiceDataForGroup: invoiceDataForGroup })
        } else {
            notification.error({
                message: "Please select atleast 1 Invoice.",
            });
        }
    }

    selectUser = (item, studentId) => {
        let cloneUserCheckBox = _.clone(this.state.userCheckBox);
        cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
        this.setState({ userCheckBox: cloneUserCheckBox });
    };


    loadApi = async () => {
        let bankData = {}
        let branchDetails = {}
        let bankDetails = await Request.getCompanyBankDetails()
        _.each(bankDetails.results, (detail) => {
            bankData[detail._id] = detail
        })
        let Apparams = {
            results: 1000,
            count: 1000,
        }
        let AssociatePartners = await Request.loadBranch(Apparams);
        _.each(AssociatePartners.data, (ap) => {
            branchDetails[ap._id] = ap
        })

        this.setState({ bankData, branchDetails })
    }


    componentWillMount() {
    }
    async componentDidMount() {
        await this.loadUniversity();
        await this.loadApi()
    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
        this.loadBranches();
    }
    showInvoive = (record) => {
        this.setState({ showInvoiveView: true, invoiceId: record._id });
    }
    closeDocument = () => {
        this.setState({ showInvoiveView: false });
    }

    sendInvoice = (invoiceId) => {
        this.setState({ showInvoiveInboxView: true, invoiceId: invoiceId });
    }
    editInvoice = (invoiceId) => {
        this.setState({ showEditInvoiceView: true, invoiceId: invoiceId });
    }
    editNewInvoice = (invoiceId) => {
        this.setState({ showEditNewInvoiceView: true, invoiceId: invoiceId });
    }

    closeEditNewInvoice = () => {
        this.table.current.reload();
        this.setState({ showEditNewInvoiceView: false });
    }

    closeEditInvoice = () => {
        this.table.current.reload();
        this.setState({ showEditInvoiceView: false });
    }

    closeGroupedPeformaDrawer = () => {
        this.setState({ showGenerateGroupPerforma: false, invoiceDataForGroup: {} }, () => {
            this.table.current.reload();
        })
    }
    updateInvoice = (invoiceId) => {
        this.setState({ showInvoiceUpdateForm: true, invoiceId: invoiceId });
    }
    updateGroupInvoiceStatus = (invoiceId) => {
        this.setState({ showGroupInvoiceStatus: true, invoiceId: invoiceId })
    }
    showStudentList = (invoiceId) => {
        this.setState({ showInvoiceStudentList: true, invoiceId: invoiceId });
    }
    clearedInvoice = async (invoiceId, generatedInvoice, invoiceStatus = 'Cleared') => {
        let formObject = { invoiceId, invoices: generatedInvoice.invoices, invoiceStatus: invoiceStatus, invoiceReceivingDate: generatedInvoice.invoiceReceivingDate }

        let x = await Request.updateInvoiceData(formObject);
        let $this = this;
        if (!x.error) {
            notification.success({
                message: 'Invoice ' + invoiceStatus + ' successfully'
            });
            setTimeout(function () {
                if ($this.table && $this.table.current) {
                    $this.table.current.reload();
                }
            }, 500);
        } else {
            notification.error({
                message: 'Error Saving',
                description: x.msg
            })
        }
    }
    createNewInvoice = async (invoiceId) => {
        let response = await Request.createNewInvoice({ invoiceId });
        if (response.error) {
            return notification.error({
                message: response.msg
            })
        } else {
            this.table.current.reload();
            return notification.success({
                message: response.msg
            })
        }
    }

    closeInvoiceInbox = () => {
        this.setState({ showInvoiveInboxView: false });
        let $this = this;
        setTimeout(function () {
            if ($this.table && $this.table.current) {
                $this.table.current.reload();
            }
        }, 500);
    }

    closeInvoiceUpdateForm = () => {
        this.setState({ showInvoiceUpdateForm: false });
        let $this = this;
        setTimeout(function () {
            if ($this.table && $this.table.current) {
                $this.table.current.reload();
            }
        }, 500);
    }
    closeGroupInvoiceStatus = () => {
        this.setState({ showGroupInvoiceStatus: false });
        let $this = this;
        setTimeout(function () {
            if ($this.table && $this.table.current) {
                $this.table.current.reload();
            }
        }, 500);
    }

    closeInvoiceStudentList = () => {
        this.setState({ showInvoiceStudentList: false });
        let $this = this;
        setTimeout(function () {
            if ($this.table && $this.table.current) {
                $this.table.current.reload();
            }
        }, 500);
    }

    loadBranches = () => {
        let params = {
            sortField: 'branchName',
            sortOrder: 'ascend',
            results: 1000,
            count: 1000,
            status: true
        }
        Request.loadBranch({ ...params })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ id: vv._id, display: vv.branchName })
                    return temp
                }, [])
                this.setState({ branchs: resp.data });
            })
            .catch(err => {
                console.log(err)
            })
    }

    chooseRangerPicker = (date, dateString) => {
        this.setState(
            {
                time: {
                    from: date[0],
                    to: date[1]
                }
            }, () => {
                if (date[0] == undefined) {
                    if (this.table && this.table.current) {
                        this.table.current.reload();
                    }
                }
            }
        )
    }

    onOk = value => {
        if (this.table && this.table.current) {
            this.table.current.reload();
        }
    }

    openFollowUps = (record) => {
        invoiceObj = {
            invoiceToName: record.invoiceToName,
            invoiceToEmail: record.invoiceToEmail,
            _id: record._id,
        };
        this.setState({ showFollowUp: true });
    };

    closeFollowUp = () => {
        this.setState({
            showFollowUp: false,
        }, () => {
            this.table.current.reload()
        });
    };

    onChangeDatePicker = (date) => {

        this.setState(
            {
                courseStartDate: {
                    from: moment(date).startOf('month').toDate(),
                    to: moment(date).endOf('month').toDate()
                }
            }, () => {
                this.table.current.reload()
            }
        );
    }

    render() {
        const { dispatch } = this.props

        const { total, cp, showInvoiveView, showEditNewInvoiceView, showEditInvoiceView, invoiceId, showInvoiveInboxView, showInvoiceUpdateForm, showGroupInvoiceStatus, showInvoiceStudentList, branchs } = this.state;
        const columns = [
            {
                title: "S. No.",
                key: 'serialNumber',
                width: 50,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },

            {
                title: "View Summary",
                key: "operation",
                width: 190,
                render: (text, record) => (
                    <div className={styles.btnWrapper}>
                        <React.Fragment>
                            {
                                record.invoiceStatus == 'Generated' || (record.grouped == true && record.invoiceStatus == "Draft") ?
                                    <>
                                        <Tooltip title="Send invoice to recipient">
                                            <Button
                                                loading={false}
                                                className={styles.btn}
                                                onClick={() => { this.sendInvoice(record._id) }}
                                                shape="circle"
                                                icon="forward"
                                            />
                                        </Tooltip>
                                    </>
                                    : null
                            }

                            {
                                record.invoiceStatus == 'Submitted to Uni' || record.invoiceStatus == 'Approved by Uni' ?
                                    <>
                                        <Tooltip title="View Student List">
                                            <Button
                                                loading={false}
                                                className={styles.btn}
                                                onClick={() => { this.showStudentList(record._id) }}
                                                shape="circle"
                                            ><FaServer /></Button>
                                        </Tooltip>
                                        {
                                            record.structure === "new" ?
                                                <Tooltip title="Change Statuss">
                                                    <Button
                                                        loading={false}
                                                        className={styles.btn}
                                                        onClick={() => { this.updateGroupInvoiceStatus(record._id) }}
                                                        shape="circle"
                                                        icon="edit"
                                                    />
                                                </Tooltip>
                                                :
                                                <Tooltip title="Change Status">
                                                    <Button
                                                        loading={false}
                                                        className={styles.btn}
                                                        onClick={() => { this.updateInvoice(record._id) }}
                                                        shape="circle"
                                                        icon="edit"
                                                    />
                                                </Tooltip>
                                        }

                                    </>
                                    : null
                            }
                            {
                                record.invoiceStatus == 'Approved by Uni' ?
                                    <>
                                        <Tooltip title="Approved by Uni">
                                            <Button
                                                loading={false}
                                                className={styles.btn}
                                                onClick={() => { this.clearedInvoice(record._id, record, 'Paid by Uni') }}
                                                shape="circle"
                                            ><FaAmazonPay style={{ width: '18px' }} /></Button>
                                        </Tooltip>
                                    </>
                                    : null
                            }
                            {
                                record.invoiceStatus == 'Paid by Uni' ?
                                    <>
                                        <Tooltip title="Mark 'Paid'">
                                            <Button
                                                loading={false}
                                                className={styles.btn}
                                                onClick={() => { this.clearedInvoice(record._id, record, 'Cleared') }}
                                                shape="circle"
                                                icon="check"
                                            />
                                        </Tooltip>
                                    </>
                                    : null
                            }
                            {/* {
                record.invoiceStatus != 'Paid by Uni' && record.invoiceStatus != 'Cleared' && record.invoiceStatus != 'Original Invoice Created' && record.grouped == true ?
                  <Tooltip title="Edit Invoice">
                    <Button
                      loading={false}
                      className={styles.btn}
                      onClick={() => { this.editGroupedInvoice(record._id) }}
                      shape="circle"
                    ><FaRegEdit /></Button>
                  </Tooltip>
                  : null
              } */}
                            {
                                record.invoiceStatus != 'Paid by Uni' && record.invoiceStatus != 'Cleared' && record.invoiceStatus != 'Original Invoice Created' && record.structure == "new" ?
                                    <Tooltip title="Edit Invoices">
                                        <Button
                                            loading={false}
                                            className={styles.btn}
                                            onClick={() => { this.editNewInvoice(record._id) }}
                                            shape="circle"
                                        ><FaRegEdit /></Button>
                                    </Tooltip>

                                    : null
                            }
                            {
                                record.invoiceStatus != 'Paid by Uni' && record.invoiceStatus != 'Cleared' && record.invoiceStatus != 'Original Invoice Created' && record.structure != "new" ?
                                    <Tooltip title="Edit Invoice">
                                        <Button
                                            loading={false}
                                            className={styles.btn}
                                            onClick={() => { this.editInvoice(record._id) }}
                                            shape="circle"
                                        ><FaRegEdit /></Button>
                                    </Tooltip>
                                    : null
                            }
                            <Tooltip title="View Invoice ">
                                <Button
                                    loading={false}
                                    className={styles.btn}
                                    onClick={() => { this.showInvoive(record) }}
                                    shape="circle"
                                    icon="eye"
                                />
                            </Tooltip>
                            {
                                record.invoiceStatus == 'Draft' && record.invoiceType == 'Performa' && record.grouped == false ?
                                    <Tooltip title="Create Original Invoice">
                                        <Button
                                            loading={false}
                                            className={styles.btn}
                                            onClick={() => { this.createNewInvoice(record._id) }}
                                            shape="circle"
                                            icon="plus"
                                        />
                                    </Tooltip>
                                    : null
                            }
                            {
                                record.invoiceStatus == 'Draft' || record.invoiceStatus == 'Submitted to Uni' || record.invoiceStatus == 'Generated' ?
                                    <Tooltip title="FollowUps">
                                        <Button
                                            className={styles.btn}
                                            size={"small"}
                                            shape="circle"
                                            onClick={() => this.openFollowUps(record)}
                                            icon="calendar"
                                        />
                                    </Tooltip>
                                    : null
                            }

                            <Checkbox key={record._id._id}
                                checked={
                                    userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false
                                }
                                onChange={(y) => {
                                    this.selectUser(y, record._id);
                                }}
                            />
                        </React.Fragment>
                    </div>
                ),
            },
            {
                title: 'Visa Date',
                key: 'visaDate',
                width: 120,
                render: (text, record) => {
                    if (record.inquiry) {
                        return (
                            <div className={styles.wrap}>
                                <React.Fragment>
                                    {moment(record.inquiry.visaDesk.visaApprovalDate).format(dateFormat)}
                                </React.Fragment>
                            </div>
                        )
                    }
                }
            },
            {
                title: "VID",
                key: 'studentVisionId',
                width: 70,
                searchTextName: 'Student Vision Id',
                filterRegex: true
            },
            {
                title: 'Student Name',
                key: 'studentName',
                width: 110
            },
            {
                title: 'PPT',
                key: 'passportNumber',
                width: 110
            },
            {
                title: 'DOB',
                key: 'inquiry.dateOfBirth',
                width: 110,
                render: (text, record) => {
                    if (record.inquiry) {
                        return (
                            <div className={styles.wrap}>
                                <React.Fragment>
                                    {moment(record.inquiry.dateOfBirth).format(dateFormat)}
                                </React.Fragment>
                            </div>
                        )
                    }
                }
            },
            {
                title: 'Student Id',
                key: 'instituteStudentId',
                width: 110
            },
            {
                title: 'Branch',
                key: 'studentBranchName',
                width: 110
            },
            {
                title: 'Associate Partner/Branch',
                key: 'branchDetails.branchName',
                width: 110,
            },
            {
                title: 'College Name',
                key: 'inquiry.visaDesk.selectedCourse.universityInstitutionName',
                width: 120
            },
            {
                title: 'Course Name',
                key: 'inquiry.visaDesk.selectedCourse.courseName',
                width: 120,
            },
            {
                title: 'Start Date / Term',
                key: 'inquiry.visaDesk.courseStartDate',
                width: 110,
                render: (text, record) => {
                    if (record.inquiry) {
                        return (
                            <div className={styles.wrap}>
                                <React.Fragment>
                                    {moment(record.inquiry.visaDesk.courseStartDate).format(dateFormat)}
                                </React.Fragment>
                            </div>
                        )
                    }
                }
            },
            {
                title: 'Currency',
                key: 'currency',
                width: 110,
            },
            {
                title: 'Share Percentage/Flat',
                key: 'commissionFromCourse',
                width: 110,
                render: (text, record) => {
                    return (
                        <div className={styles.wrap}>
                            <React.Fragment>
                                {`${record.commissionFromCourse}(${record.commissionTypeFrom})`}
                            </React.Fragment>
                        </div>
                    )
                }
            },
            {
                title: 'Invoice',
                key: 'invoiceNumber',
                dataIndex: 'invoiceNumber',
                width: 90,
                searchTextName: 'invoiceNumber',
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            {record.invoiceNumber}
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'Generated Date',
                key: 'invoiceGeneratedDate',
                dataIndex: 'invoiceGeneratedDate',
                width: 100,
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            {moment(record.invoiceGeneratedDate).format(dateFormat)}
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'Tution Fee Paid',
                key: 'tutionFee',
                width: 110,
            },
            {
                title: 'Sub Total',
                key: 'commissionSubTotal',
                width: 100,
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            {record.currency}- {record.commissionSubTotal.toFixed(2)}
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'Tax',
                key: 'commissionTaxTotal',
                width: 100,
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            {record.invoices && record.invoices.length > 0 ? record.invoices[0].currency : ''} {record.commissionTaxTotal.toFixed(2)}
                            {
                                record.taxDetails ?
                                    record.taxDetails.map((taxDetail, inIndex) => {
                                        return (<small key={inIndex}><br />({taxDetail.taxName}-{taxDetail.taxValue}%)</small>)
                                    })
                                    :
                                    <small>({record.commissionTaxType}-{record.commissionTax}%)</small>
                            }
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'Total',
                key: 'commissionGrandTotal',
                width: 100,
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            {record.currency}- {record.commissionGrandTotal.toFixed(2)}
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'Status',
                key: 'invoiceStatus',
                dataIndex: 'invoiceStatus',
                width: 80,
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            {record.invoiceStatus}
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'Follow Up',
                key: 'followUp',
                width: 130,
                render: (text, record) => {
                    if (record.inquiry) {
                        return (
                            <LatestFollowup info={record.inquiry.followUp} />
                        )
                    }
                }
            },
            {
                title: 'ARP',
                key: 'conversionRate',
                width: 80
            },
            {
                title: 'INR Received',
                key: 'receivedCommissionAmount',
                width: 80,
            },
            {
                title: 'Type',
                key: 'invoiceType',
                dataIndex: 'invoiceType',
                width: 80,
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            {record.invoiceType}
                        </React.Fragment>
                    </div>
                )
            },
            // {
            //   title: 'Invoice Details',
            //   key: 'invoices',
            //   dataIndex: 'invoices',
            //   width: 210,
            //   render: (text, record) => (
            //     <div className={styles.wrap}>
            //       <React.Fragment>
            //         <div>
            //           {
            //             record.invoices ?
            //               record.invoices.slice(0, cp ? (record.invoices.length) : 1).map((invoice, index) => {
            //                 return (<div key={index}>
            //                   <div><b>Student Name:-</b> {invoice.studentName}</div>
            //                   <div><b>Passport:-</b> {invoice.passportNumber}</div>
            //                   <div><b>Student ID:-</b> {invoice.instituteStudentId}</div>
            //                   <div><b>Branch:-</b> {invoice.studentBranchName}</div>
            //                 </div>)
            //               })
            //               : null
            //           }
            //         </div>
            //         {record.invoices && record.invoices.length > 1 ?
            //           <button style={{ color: 'red', float: 'right' }} onClick={() => {
            //             this.setState({
            //               cp: !cp
            //             })
            //           }}>
            //             {cp ? 'View Less -' : 'View More +'}
            //           </button> : null}
            //       </React.Fragment>
            //     </div>
            //   )
            // },

            {
                title: 'Created By',
                width: 120,
                key: 'createdByUser',
                // searchDateName: 'createdByUser.time',
                render: (text, record) => {
                    return (
                        <div>
                            <div >{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
        ];

        return (
            <PageHeaderWrapper title={` All Invoices: ${total} `}>
                {
                    showInvoiveView ?
                        <InvoiceView invoiceId={invoiceId} onClose={this.closeDocument} onSendInvoice={(invoiceId) => { this.sendInvoice(invoiceId) }} />
                        : null
                }
                {
                    this.state.showGenerateGroupPerforma ?
                        <GroupedPerformaInvoice invoiceIds={this.state.invoiceDataForGroup} onClose={this.closeGroupedPeformaDrawer} />
                        : null
                }
                {
                    showEditInvoiceView ?
                        <EditInvoiceView invoiceId={invoiceId} onClose={this.closeEditInvoice} />
                        : null
                }

                {
                    showEditNewInvoiceView ?
                        <EditNewInvoiceView invoiceId={invoiceId} onClose={this.closeEditNewInvoice} />
                        : null
                }

                {
                    showInvoiveInboxView ?
                        <InboxEmailView invoiceId={invoiceId} onClose={this.closeInvoiceInbox} />
                        : null
                }

                {
                    showInvoiceUpdateForm ?
                        <InvoiceUpdateForm invoiceId={invoiceId} onClose={this.closeInvoiceUpdateForm} />
                        : null
                }
                {
                    showGroupInvoiceStatus ?
                        <GroupInvoiceChangeStatus invoiceId={invoiceId} onClose={this.closeGroupInvoiceStatus} />

                        : null
                }

                {
                    showInvoiceStudentList ?
                        <InvoiceStudentList invoiceId={invoiceId} onClose={this.closeInvoiceStudentList} />
                        : null
                }

                {
                    this.state.showFollowUp ? (
                        <ListFollowUps invoiceObj={invoiceObj} onClose={this.closeFollowUp} />
                    )
                        : null
                }
                <Card style={{ marginBottom: 10 }}
                    title="Search Filters"
                    headStyle={{ paddingTop: '5px' }}
                    bordered={false}>
                    <Row>
                        <Col span={8}>
                            <div>
                                <h4>Show By Branch</h4>
                                <Select
                                    allowClear
                                    style={{ width: '90%' }}
                                    showSearch={true}
                                    value={this.state.branchId}
                                    placeholder="Select Option"
                                    optionFilterProp="display"
                                    filterOption={(input, option) => {
                                        return (
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        )
                                    }}
                                    onChange={branchId => {
                                        this.setState(
                                            {
                                                branchId: branchId && branchId.toString()
                                            },
                                            () => {
                                                setTimeout(() => {
                                                    this.table.current.reload();
                                                }, 500);
                                            }
                                        )
                                    }}>
                                    {branchs.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val.id}>
                                                {val.display}
                                            </Option>
                                        )
                                    })}
                                </Select>
                            </div>
                        </Col>
                        <Col span={8}>
                            <h4>Filter by Date</h4>
                            <RangePicker
                                style={{ width: '90%' }}
                                showTime={{ format: 'HH:mm' }}
                                format="YYYY-MM-DD HH:mm"
                                placeholder={['Start Date', 'End Date']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>
                        <Col span={8}>
                            <h4>Search By Intake</h4>
                            <MonthPicker style={{ width: '90%' }} format="YYYY-MMM" onChange={this.onChangeDatePicker} placeholder="Select Intake" />
                        </Col>
                        <Col span={8} style={{ marginTop: '10px' }}>
                            <h4>Search By University</h4>
                            <Select
                                allowClear
                                style={{ width: '90%' }}
                                showSearch={true}
                                placeholder="Select University"
                                optionFilterProp="universityInstitutionName"
                                onChange={(v) => this.setState({ universityInstitutionName: v }, () => { this.table.current.reload(); })}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {
                                    this.state.universities.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val.display}>
                                                {val.display}
                                            </Option>
                                        );
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={8} style={{ marginTop: '10px' }}>
                            <h4>Search By Status</h4>
                            <Select
                                allowClear
                                style={{ width: '90%' }}
                                showSearch={true}
                                placeholder="Select Status"
                                optionFilterProp="invoiceStatus"
                                onChange={(v) => this.setState({ invoiceStatus: v }, () => { this.table.current.reload(); })}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {
                                    ['Generated', 'Submitted to Uni', 'Approved by Uni', 'Paid by Uni', 'Cleared'].map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val}>
                                                {val}
                                            </Option>
                                        );
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={8} style={{ marginTop: '10px' }}>
                            <h4>Search By Invoice Type</h4>
                            <Select
                                allowClear
                                style={{ width: '90%' }}
                                showSearch={true}
                                placeholder="Select Type"
                                optionFilterProp="invoiceType"
                                onChange={(v) => this.setState({ invoiceType: v }, () => { this.table.current.reload(); })}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {
                                    ['Invoice', 'Performa'].map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val}>
                                                {val}
                                            </Option>
                                        );
                                    })
                                }
                            </Select>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <Button type='primary' onClick={this.generateGroupedPerformaInvoice}>Generate Grouped Invoice</Button>
                </Card>
                <Card bordered={true}>
                    <TableComp
                        key='groupedInvoice'
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        // dataSource={this.state.invoiceData}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: false,
                            defaultPageSize: 10000,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        );
    }
}

const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search,
    location: router.location,
});

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GroupedInvoices);